import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../services/api";

export const createPaiement = createAsyncThunk(
  "paiements/createPaiement",
  async (paiementData, { rejectWithValue }) => {
    try {
      const response = await api.post("/Paiement", paiementData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || "Erreur lors de l'enregistrement du paiement"
      );
    }
  }
);

export const fetchPaiementsForReservation = createAsyncThunk(
  "paiements/fetchForReservation",
  async (reservationId, { rejectWithValue }) => {
    try {
      const response = await api.get(`/Paiement/reservation/${reservationId}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message || "Erreur lors du chargement des paiements");
    }
  }
);

const paiementsSlice = createSlice({
  name: "paiements",
  initialState: {
    loading: false,
    error: null,
    success: false,
  },
  reducers: {
    resetPaiementSuccess: (state) => { state.success = false; },
    clearPaiementError: (state) => { state.error = null; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createPaiement.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(createPaiement.fulfilled, (state) => { state.loading = false; state.success = true; })
      .addCase(createPaiement.rejected, (state, action) => { state.loading = false; state.error = action.payload; });
  },
});

export const { resetPaiementSuccess, clearPaiementError } = paiementsSlice.actions;
export default paiementsSlice.reducer;
